export default __webpack_public_path__ + "static/media/peerling_agb.4d2f25dc.pdf";